import { ShowDuplicate } from './myRegistrerenShowDuplicate';

require('./myRegistrerenShowDuplicate.scss');

export const myRegistrerenShowDuplicateComponent = {
  template: require('./myRegistrerenShowDuplicate.html'),
  controllerAs: 'ctrl',
  controller: ShowDuplicate,
};
